module.exports = __webpack_public_path__ + "images/upload.a7608805e2e32199a5d1d7c856fe06ed.gif";